<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Income Statement (Profil/(Loss)) 
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="process()">
                        <i class="fa fa-play"></i>
                        Process
                    </button>
                    <button class="btn btn-primary mr-1" @click="print()">
                        <i class="fa fa-print"></i>
                        print
                    </button>
                    <button class="btn btn-primary mr-1" @click="exportxls()">
                        <i class="fa fa-file-excel-o"></i>
                        Export
                    </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                          <b-form-checkbox class="ml-3 mt-2 text-left" v-model="filter.excludekosong" value=1 unchecked-value=0 >Exclude Zero Balance</b-form-checkbox>
                  </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <b-tabs card v-model="filter.tabIndex">
                    <b-tab title="Summary 12 Months" active>
                        <div class="report-wraper">
                            <table >
                                <thead>
                                    <tr>
                                    <th width="400px">Description</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Jan {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Jan</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Feb {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Feb</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Mar {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Mar</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Apr {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Apr</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">May {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">May</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Jun {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Jun</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Jul {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Jul</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Aug {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Aug</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Sep {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Sep</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Oct {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Oct</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Nov {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Nov</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">Dec {{filter.tgl2 | moment("YYYY")}}</th>
                                    <th v-if="!filter.tgl2" style="text-align:right" width="110px">Dec</th>
                                    <th style="text-align:right" width="110px">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in cflw.lines" :key="row.idrowunik">
                                    <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row, row.jan,1)" style="text-align:right">{{row.jan | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row, row.feb,2)" style="text-align:right">{{row.feb | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mar,3)" style="text-align:right">{{row.mar | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.apr,4)" style="text-align:right">{{row.apr | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mei,5)" style="text-align:right">{{row.mei | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jun,6)" style="text-align:right">{{row.jun | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jul,7)" style="text-align:right">{{row.jul | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.agt,8)" style="text-align:right">{{row.agt | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.sep,9)" style="text-align:right">{{row.sep | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.okt,10)" style="text-align:right">{{row.okt | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.nov,11)" style="text-align:right">{{row.nov | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.des, 12)" style="text-align:right">{{row.des | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonToDate(row,row.total)" style="text-align:right">{{row.total | numFormat}}</td>
                                    <td v-else ></td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </b-tab>
                    <b-tab title="Current Month & Month To Date" active>
                        <div class="report-wraper">
                            <table style="width: 100%;">
                                <thead>
                                    <tr>
                                    <th width="110px">Src.Code</th>
                                    <th >Description</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="110px">{{filter.tgl2 | moment("MMM-YYYY")}}</th>
                                    <th v-else style="text-align:right" width="150px">Current Month</th>
                                    <th  style="text-align:right" width="110px">%</th>
                                    <th v-if="filter.tgl2" style="text-align:right" width="180px"> As of {{filter.tgl2 | moment("MMM-YYYY")}}</th>
                                    <th v-else style="text-align:right" width="180px">Month to Date</th>
                                    <th  style="text-align:right" width="110px">%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in cflw.lines" :key="row.idrowunik">
                                    <td :class="row.kelas">{{row.kode}}</td>
                                    <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillCurrentMonth(row,row.monthtt)" style="text-align:right">{{row.monthtt | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.persen_mon | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonToDate(row,row.total)" style="text-align:right">{{row.total | numFormat}}</td>
                                    <td v-else ></td>
                                    <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.persen_md | numFormat}}</td>
                                    <td v-else ></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

        <b-modal v-model="drillConfirmation" scrollable size="md" title="Drilldown Confirmation" hide-footer>
            <span>Show Detail value of <strong>{{drillSrc.uraianfmt}}</strong> , {{drillColName}} ?</span>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="drillNewtab" class="mt-1 ml-2">Open New Tab</b-form-checkbox>
            <b-row class="justify-content-center mt-1">
                <b-button variant="primary" class="ml-2" @click="drillAction('GL')" > Show in GL</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('TB')" > Show in TB</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('MODUL')" v-if="(drillModul)"> Show in subModul</b-button>
                <b-button variant="secondary" class="ml-2" @click="drillConfirmation=false" > Cancel</b-button>
            </b-row>
        </b-modal>
    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import incomestat from "../../apis/incomestat";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'',tgl1:'',tgl2:'', excludekosong:0},
      isLoading: false,
      layouts:[],
      monthLabels:["January","February","March","April","May","Juni","July","August","September","October","November","December"],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      cflw:{lines:[]},
      drillConfirmation:false,
      drillSrc:{}, drillCol:'', drillColName:'',monthOf:'', 
      drillModul:'',drillNewtab:1
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
        // this.cflw.lines= await incomestat.layout({layout : newval});
        const lines = await incomestat.layout({layout : newval});
        const hasil = lines.reduce((newArr, line) => {
            if (line.item_hapus !== 1) newArr.push(line);
            return newArr;
        }, []);          
          this.cflw.lines=hasil;
      }
  },
created: async function (){
     this.layouts = await incomestat.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.tahun=moment(this.filter.tgl1).format('YYYY');
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.cflw.lines= await incomestat.pnl(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await incomestat.pnlprint(model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.tahun=moment(this.filter.tgl1).format('YYYY');
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await incomestat.pnlexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillMonthly: function(data,nilai, monthOf)
    {
        if ((data.kode) && (nilai)) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='monthly';
            this.drillColName=`month of ${this.monthLabels[monthOf-1]} ${this.tahun}`;
            this.monthOf=monthOf;
            this.drillConfirmation=true;

                // this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, month of ${this.monthLabels[monthOf-1]} ?`, {
                // title: 'Drilldown Confirmation',
                // size: 'sm',
                // buttonSize: 'sm',
                // okVariant: 'danger',
                // okTitle: 'YES',
                // cancelTitle: 'NO',
                // footerClass: 'p-2',
                // hideHeaderClose: false,
                // centered: true
                // })
                // .then(value => {
                //     if (value==true) {
                //         var tgl1 = moment(`${this.tahun}-${monthOf}-01`,'YYYY-MM-DD');
                //         let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
                //         window.open(routeData.href, '_blank');
                //     }
                // })
                // .catch(err => {
                //     console.log('msgBoxConfirm error', err);
                // })
        }
    },
    drillCurrentMonth: function(data, nilai)
    {
        if ((data.kode) && (nilai)) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='currentMonth';
            this.drillColName=`month of ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() }`;
            this.drillConfirmation=true;
                // this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, current month ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() } ?`, {
                // title: 'Drilldown Confirmation',
                // size: 'sm',
                // buttonSize: 'sm',
                // okVariant: 'danger',
                // okTitle: 'YES',
                // cancelTitle: 'NO',
                // footerClass: 'p-2',
                // hideHeaderClose: false,
                // centered: true
                // })
                // .then(value => {
                //     if (value==true) {
                //         var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                //         let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
                //         window.open(routeData.href, '_blank');
                //     }
                // })
                // .catch(err => {
                //     console.log('msgBoxConfirm error', err);
                // })
        }
    },
    drillMonToDate: function(data, nilai)
    {
        if ((data.kode) && (nilai)) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='monToDate';
            this.drillColName=`as of ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() }`;
            this.drillConfirmation=true;

                // this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, as of ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() } ?`, {
                // title: 'Drilldown Confirmation',
                // size: 'sm',
                // buttonSize: 'sm',
                // okVariant: 'danger',
                // okTitle: 'YES',
                // cancelTitle: 'NO',
                // footerClass: 'p-2',
                // hideHeaderClose: false,
                // centered: true
                // })
                // .then(value => {
                //     if (value==true) {
                //         let routeData = router.resolve({path: `general-ledger/${data.kode}/${this.filter.tgl1}/${this.filter.tgl2}`});
                //         window.open(routeData.href, '_blank');
                //     }
                // })
                // .catch(err => {
                //     console.log('msgBoxConfirm error', err);
                // })

        }
    },
 
    cekModule: function(kodeacc) {
        this.drillModul='';
        if (kodeacc.startsWith('140')) {
            this.drillModul='receivable.araging';
        } else if (kodeacc.startsWith('141')) {
            this.drillModul='advance.advaging';
        } else if (kodeacc.startsWith('142')) {
            this.drillModul='accounting.loanaraging';
        } else if (kodeacc.startsWith('150')) {
            this.drillModul='logistic.rptbalance';
        } else if (kodeacc.startsWith('210')) {
            this.drillModul='payable.apsummary';
        }    
    },
    drillAction(drillTarget){
        let drillRoute;
        switch (drillTarget) {
            case 'TB':
                if (this.drillCol=='monthly') {
                    var tgl1 = moment(`${this.tahun}-${this.monthOf}-01`,'YYYY-MM-DD');
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                } else if (this.drillCol=='currentMonth') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY-MM')}-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='monTodate') {
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:this.filter.tgl1, tgl2: this.filter.tgl2}};
                }                    
                break;
        
            case 'MODUL':
                if (this.drillCol=='monthly') {
                    var tgl1 = moment(`${this.tahun}-${this.monthOf}-01`,'YYYY-MM-DD');
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                } else if (this.drillCol=='currentMonth') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY-MM')}-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='monTodate') {
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:this.filter.tgl1, tgl2: this.filter.tgl2}};
                }                    
                break;
        
            default:
                if (this.drillCol=='monthly') {
                    var tgl1 = moment(`${this.tahun}-${this.monthOf}-01`,'YYYY-MM-DD');
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                } else if (this.drillCol=='currentMonth') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY-MM')}-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='monTodate') {
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:this.filter.tgl1, tgl2: this.filter.tgl2}};
                }                    
                break;
        }
        if (drillRoute) {
            if (this.drillNewtab==1) {
                const routeData = router.resolve(drillRoute);
                window.open(routeData.href, '_blank');
            } else {
                router.push(drillRoute);                
            }
        }
    },

    close(){
      router.push("home");
    }
  }
};
</script>
